import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Card, Image } from "react-bootstrap";
import { IoIosArrowDown } from "react-icons/io";
import "./banner.scss";
import { fetchApi } from "../../../../../service/services";
import ContentShimmer from "react-content-shimmer";
import { HashLink as Link } from 'react-router-hash-link';
interface BannerItem {
  id: number;
  acf: {
    flyer_upload:  string;
  };
}

export const Banner = () => {
  const [bannerFlyer, setBannerFlyer] = useState<BannerItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchApi('banner_home')
      .then((data) => {
        setBannerFlyer(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return (
      <Container>
        <ContentShimmer
          style={{ marginTop: "1rem", width: "w-100", height: "500px" }}
          rounded={"10px"}
        />
      </Container>
    );
  } else if (!isLoading && Object.keys(bannerFlyer).length === 0) {
    return (
      <Container fluid id="banner-section">
        <Row className="banner-try mt-5 p-5 position-relative row row-cols-xs-1">
          <Col
            xs={{ order: 2 }}
            md={{ order: 1 }}
            className="banner-col-1 p-5"
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="500"
            data-aos-once="false"
            data-aos-anchor-placement="top-center"
          >
            <div className="banner-col-1-text text-white">
              <p className="fw-bold  text-break">
                Buyers post <span className="fw-light">what</span>
              </p>
              <p className="fw-light text-break"> they want to buy,</p>
              <p className="fw-bold text-break">sellers reply. </p>
            </div>
            <div className="text-white banner-text-sub fs-4">
              <span>That's the Pamo way!</span>
            </div>
            <div className="mt-4 btn-section d-flex align-items-center">
              <div>
              <Link to="https://bit.ly/PamoApp">
              <Button
                variant="info"
                className=" fw-bold py-4 px-4 text-white  download-btn"
              >
                <span className="download-btn-text ">Download for Android or IOS</span>
              </Button>{" "}
              </Link>
              </div>
            
              <div className="scroll-down-to-section">
              <Link smooth to="#what-is-pamo-container"
                  className="text-white fw-bold text-link  text-decoration-underline mx-3"
                >
                  {" "}
                  What is Pamo?
                </Link>
              </div>
            </div>
          </Col>
          <Col
            xs={{ order: 1 }}
            md={{ order: 2 }}
            className="banner-col-2 mt-5  position-relative"
          >
            <div className="background-image-col-home">
              <Card className="card-on-hover p-3 ">
                <Card.Body className="position-relative">
                  <div className=" rounded-circle text-end">
                    <div className="rounded-circle bg-info spot d-inline-block p-2"></div>
                  </div>
                  <div className="alternating-images-on-hover-home"></div>
                </Card.Body>
                <Card.Footer className="card-on-hover-footer text-center">
                  post made!
                </Card.Footer>
              </Card>
            </div>
          </Col>
          
          <div className="text-end position-absolute floating-btn-home">
          <Link smooth to="#what-is-pamo-container">
           <Button className="p-4 rounded-circle btn-glass border-0">
              <IoIosArrowDown className="text-white fw-bolder fs-2" />
            </Button>
            </Link>
          </div>
         
         
        </Row>
      </Container>
    );
  } else {
    return (
      <Container id="promo-section">
        {bannerFlyer.map((item, key) => (
          <div className="promo-banner" key={key}>
            <Image
              className="flyer"
              src={item?.acf?.flyer_upload}
              key={item?.id}
            />
          </div>
        ))}
      </Container>
    );
  }
};
